import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { z } from 'zod';
import { SearchPage } from '@/features/search';

const SearchParamsSchema = z.object({
  q: z.string().optional(),
  scope: z
    .enum([
      'all',
      'articles',
      'files',
      'folders',
      'groups',
      'members',
      'forum',
      'comments',
      'annotations',
      'surveys',
      'calendar',
      'scheduling',
      'coordination',
      'bookmarks',
      'newsletters',
      'taxonomy',
    ])
    .optional(),
});

export const Route = createFileRoute('/search')({
  component: SearchRoute,
  validateSearch: (search) => SearchParamsSchema.parse(search),
});

function SearchRoute(): ReactNode {
  const search = Route.useSearch();
  return (
    <SearchPage
      {...(search.q !== undefined ? { q: search.q } : {})}
      {...(search.scope !== undefined ? { scope: search.scope } : {})}
    />
  );
}
